import React from 'react';
import * as styles from './MagneticWallItemAvatar.module.scss';
import Avatar from '../components/Avatar';
import { gql } from '../graphql/generated/gql';
import type { DocumentType } from '../graphql/generated/gql';

const AVATAR_SIZE = parseInt(styles.avatarSize, 10) || 28;

const USER_FRAGMENT = gql(`
  fragment MagneticWallItemAvatar_user on UserFields {
    ...Avatar_user
  }
`);

interface MagneticWallItemAvatarProps {
  user: DocumentType<typeof USER_FRAGMENT>;
}

const MagneticWallItemAvatar = ({ user }: MagneticWallItemAvatarProps) => {
  return <Avatar size={AVATAR_SIZE} user={user} />;
};

export default MagneticWallItemAvatar;
